import { useMemo } from 'react';
import { isAutomaticRecurringPayment } from '../helpers/paymentHelper';

const useIsAutomaticRecurringPayment = (paymentFrequency) => useMemo(
  () => isAutomaticRecurringPayment(paymentFrequency),
  [paymentFrequency],
);

export default useIsAutomaticRecurringPayment;
